import { useQuery } from "@tanstack/react-query";
import { DepartmentService } from "../../../../services/lookup-data/department.service";

export const useDocumentDepartment = () => {
  return useQuery({
    queryKey: ["document-department"],
    queryFn: () => DepartmentService.getList(),
    select: (res: any) => res.map((d: any) => ({ value: d.Id, label: d.Name })),
  });
};
